//导入T信图片
import pic_word from "@/assets/images/new/jianjie11@2x.png";
import build_app from "@/assets/images/new/teamwork-build-app@2x.png";
import logo from "@/assets/images/new/logo@2x.png";
import code from "@/assets/images/new/cost-logo.png";
import wmcode from "@/assets/images/new/download@2x.png"
import codeTest from "@/assets/images/download-code-test.png";

//导入obg图片
import pic_word_obg from "@/assets/images/pic_word_obg.png";
import build_app_obg from "@/assets/images/build_app_obg.png";
import logo_obg from "@/assets/images/logo_obg.png";
import code_obg from "@/assets/images/code-obg.png";
import codeTest_obg from "@/assets/images/code-obg-test.png";

//定义图片路径对象
const urlList = {
    //T信正式
    tChat: {
        lang: navigator.language.substr(0, 2),
        iosDown: "Ti9f1nQ7",
        appId: 0,
        pic_word,
        build_app: build_app,
        logo: logo,
        code: code,
        wmcode: wmcode,
        iosUrl:"https://teamworkdl.getech.cn/csot.mobileprovision",
        // winUrl: "https://teamwork.getech.cn/package/tchat.exe",//以前的官网地址，基本不用了
        // macUrl: "https://teamwork.getech.cn/package/tchat.dmg",//以前的官网地址，基本不用了
        winUrl: "https://teamworkdl.getech.cn/csot_tchat.exe",
        macUrl: "https://teamworkdl.getech.cn/csot_tchat.dmg",
        andriodUrl: "https://teamworkdl.getech.cn/csot_tchat.apk",
        andriod32Url: "https://twdownload.tcl.com/tchat-upgrade/csot_tchat_32.apk",
        appleVerify: 'https://teamwork.getech.cn/thea/app/auth/weblogin.do',
        websiteDirectory: 'https://teamwork.getech.cn/hades/website/directory.do',
        websiteContent: 'https://teamwork.getech.cn/hades/website/content.do',
        websiteContentZip: 'https://teamwork.getech.cn/hades/website/content/g.do'
    },
    //T信测试
    tChatTest: {
        lang: navigator.language.substr(0, 2),
        iosDown: "Ti9f1nQ7",
        appId: 1,
        pic_word: pic_word,
        build_app: build_app,
        logo: logo,
        code: codeTest,
        wmcode: wmcode,
        iosUrl:"https://mtest.getech.cn/t-tchat-upgrade/csot.mobileprovision",
        winUrl: "https://mtest.getech.cn/csot_tchat.exe",
        macUrl: "https://mtest.getech.cn/csot_tchat.dmg",
        andriodUrl: "https://mtest.getech.cn/t-tchat-upgrade/csot_tchat.apk",
        andriod32Url: "https://mtest.getech.cn/t-tchat-upgrade/csot_tchat_32.apk",
        appleVerify: 'https://mtest.getech.cn/thea/app/auth/weblogin.do',
        websiteDirectory: 'https://mtest.getech.cn/hades/website/directory.do',
        websiteContent: 'https://mtest.getech.cn/hades/website/content.do',
        websiteContentZip: 'https://mtest.getech.cn/hades/website/content/g.do'
    },
    //OBG正式
    obg: {
        lang: navigator.language.substr(0, 2),
        iosDown: "kMWC2ZQD",
        appId: 2,
        pic_word: pic_word_obg,
        build_app: build_app_obg,
        logo: logo_obg,
        code: code_obg,
        winUrl: "https://teamworkdl.getech.cn/tlink.exe",
        macUrl: "https://teamworkdl.getech.cn/tlink.dmg",
        andriodUrl: "https://teamworkdl.getech.cn/tlink.apk",
        // appleVerify:'https://teamwork.getech.cn/thea/app/auth/weblogin.do'
        appleVerify: 'https://tlink.getech.cn/thea/app/auth/weblogin.do'
    },
    //OBG测试
    obgTest: {
        lang: navigator.language.substr(0, 2),
        iosDown: "kMWC2ZQD",
        appId: 3,
        pic_word: pic_word_obg,
        build_app: build_app_obg,
        logo: logo_obg,
        code: codeTest_obg,
        winUrl: "https://mtest.getech.cn/obg/package/tlink.exe",
        macUrl: "https://mtest.getech.cn/obg/package/tlink.dmg",
        andriodUrl: "https://mtest.getech.cn/obg/package/tlink.apk",
        // appleVerify:'https://tlink.getech.cn/thea/app/auth/weblogin.do'
        appleVerify: 'https://mtest.getech.cn/thea/app/auth/weblogin.do'
    },
}

// 0:T信正式; 1:T信测试; 2:obg正式; 3:obg测试;
let appId = 0
let url
switch (appId) {
    case 0:
        url = urlList.tChat;
        break;
    case 1:
        url = urlList.tChatTest;
        break;
    case 2:
        url = urlList.obg;
        break;
    case 3:
        url = urlList.obgTest;
        break;

    default:
        break;
}
//导出所需对象
export default url
